import { Grid, Header, Button, Message, Popup, Icon } from 'semantic-ui-react';
import { DelayedMessage } from '../../utils';


const ShowStatusMessages = ({ isAvatarUploading, avatarUploadError, successMessage, errorMessage }) => {
  return (
    <div>
      <Grid.Row className="noFiveTopNoBottomPad">
        <Grid.Column width={16}>
          <DelayedMessage
            visible={isAvatarUploading}
            type="info"
            delay={100} // Short delay for uploading message
          >
            <Icon name="spinner" loading />
            <span>Uploading avatar...</span>
          </DelayedMessage>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row className="noFiveTopNoBottomPad">
        <Grid.Column width={16}>
          <DelayedMessage
            visible={!!avatarUploadError}
            type="negative"
            header="Upload Error"
            delay={300}
          >
            <p>{typeof avatarUploadError === 'string' ? avatarUploadError : avatarUploadError?.message || 'An unknown error occurred'}</p>
          </DelayedMessage>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={16}>
          <DelayedMessage
            visible={!!successMessage}
            type="positive"
            header="Success"
            delay={0} // No delay for success messages
          >
            <p>{successMessage}</p>
          </DelayedMessage>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={16}>
          <DelayedMessage
            visible={!!errorMessage}
            type="negative"
            header="Error"
            delay={300}
          >
            <p>{errorMessage}</p>
          </DelayedMessage>
        </Grid.Column>
      </Grid.Row>
    </div>
  )

}
export default ShowStatusMessages;